import { platforms } from '@/mocks/home';

export default function PlatformRecommend() {
  const featuredPlatforms = platforms.filter((p) => p.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            精选视频平台推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            经过我们团队严格筛选，为您推荐最值得使用的<strong>在线看视频</strong>平台，<strong>高清免费</strong>观影无忧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featuredPlatforms.map((platform) => (
            <a
              key={platform.id}
              href={`/article/${platform.slug}`}
              className="group bg-background-100 rounded-xl p-5 md:p-6 flex items-start gap-4 md:gap-5 hover:bg-background-200/70 transition-all duration-300 cursor-pointer border border-background-200/60"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 rounded-xl overflow-hidden bg-background-200">
                <img
                  src={platform.logo}
                  alt={platform.name}
                  className="w-full h-full object-cover"
                  title={`${platform.name} - 好用的在线视频平台`}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <h3 className="text-base md:text-lg font-semibold text-foreground-950 whitespace-nowrap">
                    {platform.name}
                  </h3>
                  <span className="flex items-center gap-1 text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {platform.rating}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {platform.description}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {platform.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs bg-secondary-50 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400 ml-auto whitespace-nowrap">
                    <i className="ri-user-line mr-1"></i>{platform.users}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
          {platforms.filter((p) => !p.featured).map((platform) => (
            <a
              key={platform.id}
              href={`/article/${platform.slug}`}
              className="group bg-background-100 rounded-xl p-4 text-center hover:bg-background-200/70 transition-all duration-300 cursor-pointer border border-background-200/60"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl overflow-hidden bg-background-200">
                <img
                  src={platform.logo}
                  alt={platform.name}
                  className="w-full h-full object-cover"
                  title={platform.name}
                />
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1 whitespace-nowrap">{platform.name}</h3>
              <div className="flex items-center justify-center gap-1 text-xs text-foreground-500">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                {platform.rating}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}